import {
  useState,
} from "react"

import {
  Box,
  CssBaseline,
  Toolbar,
} from "@mui/material"

import Topbar from "../components/Topbar"
import Sidebar from "../components/Sidebar"


const drawerWidth =
  240


function MainLayout({
  children,
}) {
  const [
    mobileOpen,
    setMobileOpen,
  ] = useState(false)


  const handleMobileMenuOpen =
    () => {
      setMobileOpen(true)
    }


  const handleMobileMenuClose =
    () => {
      setMobileOpen(false)
    }


  return (
    <Box
      sx={{
        display:
          "flex",

        width:
          "100%",

        minWidth:
          0,

        minHeight:
          "100dvh",

        overflowX:
          "hidden",

        backgroundColor:
          "#f4f7fb",
      }}
    >
      <CssBaseline />


      <Topbar
        drawerWidth={
          drawerWidth
        }

        onMobileMenuClick={
          handleMobileMenuOpen
        }
      />


      <Sidebar
        drawerWidth={
          drawerWidth
        }

        mobileOpen={
          mobileOpen
        }

        onMobileClose={
          handleMobileMenuClose
        }
      />


      <Box
        component="main"

        sx={{
          flexGrow: 1,

          minWidth: 0,

          width: {
            xs: "100%",

            lg:
              `calc(100% - ${drawerWidth}px)`,
          },

          minHeight:
            "100dvh",

          backgroundColor:
            "#f4f7fb",

          overflowX:
            "hidden",
        }}
      >
        <Toolbar
          sx={{
            minHeight: {
              xs: 58,
              sm: 62,
              lg: 66,
            },
          }}
        />


        <Box
          sx={{
            width:
              "100%",

            minWidth:
              0,

            maxWidth:
              "100%",

            px: {
              xs: 0.5,
              sm: 0.75,
              md: 1,
              lg: 1.25,
            },

            py: {
              xs: 0.75,
              sm: 1,
              lg: 1.25,
            },
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}


export default MainLayout
